import { __awaiter, __generator } from "tslib";
;
// https://github.com/wix-private/wix-answers-server/blob/dbd842a6ba9747c1c4df1d48b71cdbb3e9a244c8/answers/wix-answers-core/src/main/java/com/wixpress/answers/common/exceptions/Errors.java#L124
export var InstagramErrorCode;
(function (InstagramErrorCode) {
    InstagramErrorCode[InstagramErrorCode["CONNECT_OR_RECONNECT_GENERIC_ERROR"] = -220010] = "CONNECT_OR_RECONNECT_GENERIC_ERROR";
    InstagramErrorCode[InstagramErrorCode["ACCOUNT_ALREADY_CONNECTED_TO_OTHER_TENANT"] = -220011] = "ACCOUNT_ALREADY_CONNECTED_TO_OTHER_TENANT";
})(InstagramErrorCode || (InstagramErrorCode = {}));
export var instagramRelativePath = '/instagram';
/**
 * @deprecated Instagram API is deprecated and will be removed in future versions
 */
export var createInstagramApi = function (_baseUrl, _http) {
    return {
        goToConnectAccount: function () {
            console.warn('Instagram API is deprecated: goToConnectAccount is a no-op');
        },
        reconnectAccount: function () {
            console.warn('Instagram API is deprecated: reconnectAccount is a no-op');
        },
        disconnectAccount: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.warn('Instagram API is deprecated: disconnectAccount is a no-op');
                return [2 /*return*/, Promise.resolve()];
            });
        }); },
        getAccounts: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.warn('Instagram API is deprecated: getAccounts is a no-op');
                return [2 /*return*/, Promise.resolve([])];
            });
        }); },
        updateAccountSettings: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.warn('Instagram API is deprecated: updateAccountSettings is a no-op');
                return [2 /*return*/, Promise.resolve()];
            });
        }); },
    };
};
//# sourceMappingURL=index.js.map